module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.emitClickAway),
      expression: "emitClickAway"
    }],
    staticClass: "sub-popover__content"
  }, [(_vm.isActiveEvents) ? [_c('div', {
    staticClass: "sub-popover__content__active__lessons__header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.activeEvents.length === 1 ? _vm.i18n[this.locale]['lesson'] : _vm.i18n[this.locale]['lessons']) + " " + _vm._s(_vm.i18n[this.locale]['selected']) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "sub-popover__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeEventsStatus),
      expression: "activeEventsStatus"
    }],
    staticClass: "do-select active-events__select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.activeEventsStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.setStatusOnActiveEvents($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['choose_status']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['set_handled']))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['set_not_handled']))])]), _vm._v(" "), _c('div', {
    staticClass: "active-events__select"
  }, [_c('d-select-subs-active-events', {
    attrs: {
      "possibleSubs": _vm.possibleSubs,
      "activeEvents": _vm.activeEvents,
      "isLoading": _vm.isActiveEventsLoading,
      "placeholder": _vm.$t('vue2.sub_scheduler.choose_sub'),
      "addClass": ['small-font']
    },
    on: {
      "add": _vm.addSubToActiveEvents
    }
  })], 1), _vm._v(" "), (_vm.hasActiveEventsWithSubs) ? _c('button', {
    staticClass: "do-bttn do-bttn--danger",
    staticStyle: {
      "margin": "0.5rem",
      "width": "calc(100% - 1rem)"
    },
    attrs: {
      "disabled": _vm.isActiveEventsLoading || _vm.activeEvents.length < 1
    },
    on: {
      "click": function($event) {
        _vm.isConfirmRemoveSubs = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-user-minus",
    staticStyle: {
      "margin-right": "6px"
    }
  }), _vm._v("\n        " + _vm._s(_vm.i18n[this.locale]['remove_substitutes']) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isConfirmRemoveSubs) ? _c('ModalConfirmation', {
    attrs: {
      "isSubmitButtonLoading": _vm.isActiveEventsLoading,
      "appendToBody": true,
      "isShowConfirmDeleteMessage": false,
      "showClose": false
    },
    on: {
      "close": function($event) {
        _vm.isConfirmRemoveSubs = false
      },
      "confirm": _vm.confirmRemoveSubs
    }
  }, [_c('h3', {
    staticClass: "pad-1",
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['remove_substitutes']) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "pad-1",
    attrs: {
      "slot": "custom_warning"
    },
    slot: "custom_warning"
  }, [_c('p', {
    staticClass: "marg-0-top"
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['confirm_remove_substitutes_text']))]), _vm._v(" "), _c('table', {
    staticClass: "do-table do-table--striped",
    staticStyle: {
      "font-size": "11px"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Vikar")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Vikar for")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.subsRemovalList), function(row, idx) {
    return _c('tr', {
      key: 'rm-' + idx
    }, [_c('td', [_vm._v(_vm._s(row.subName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.forName))])])
  }), 0)])]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "confirmText"
    },
    slot: "confirmText"
  }, [_vm._v(_vm._s(_vm.i18n[this.locale]['remove_substitutes']))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "active-events"
  }, _vm._l((_vm.activeEvents), function(activeEvent) {
    return _c('li', {
      key: activeEvent.calendar_id + activeEvent.event_id,
      staticClass: "active-events__event",
      class: {
        'active-events__event--handled': activeEvent.lesson && activeEvent.lesson.v_status && activeEvent.lesson.v_status === 1
      }
    }, [_c('div', {
      staticClass: "active-events__event__border-left",
      style: ({
        'backgroundColor': activeEvent.lesson.color
      })
    }), _vm._v(" "), _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(activeEvent.lesson.title))]), _vm._v(", "), _c('i', [_vm._v(_vm._s(activeEvent.lessonLTTime))])]), _vm._v(" "), _c('p', [_c('span', {
      staticClass: "icon-user2"
    }), _vm._v(_vm._s(activeEvent.user_to_substitute))]), _vm._v(" "), (activeEvent.selectedSubs && activeEvent.selectedSubs.length > 0) ? _c('p', [_c('span', {
      staticClass: "icon-users3"
    }), _vm._v("\n                " + _vm._s(activeEvent.selectedSubs.map(function (u) { return u.name; }).join(', ')) + "\n              ")]) : _vm._e()]), _vm._v(" "), (_vm.isActiveEventsLoading) ? _c('div', {
      staticClass: "do-spinner"
    }) : _vm._e()])
  }), 0)], 1)] : [_c('div', {
    staticClass: "sub-popover__content__header",
    style: ({
      'backgroundColor': _vm.lesson.color
    })
  }, [(_vm.lesson.event_type === 'absence') ? _c('h3', [_vm._v(_vm._s(_vm.getUser(_vm.lesson.calendar_id)))]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.lesson.title) + ",\n        "), _vm._l((_vm.klassesOnLesson), function(klass) {
    return _c('a', {
      staticClass: "link-white marg-5-right",
      attrs: {
        "href": klass.url,
        "target": "blank"
      }
    }, [_vm._v("\n          " + _vm._s(klass.name) + "\n          "), _c('span', {
      staticClass: "icon-calendar5",
      attrs: {
        "aria-hidden": "true"
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clock-and-delete"
  }, [_c('p', [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm._f("time")(_vm.lesson.start)) + " - " + _vm._s(_vm._f("time")(_vm.lesson.end)))]), _vm._v(" "), (_vm.lesson.event_type !== 'absence') ? _c('DDropdown', {
    attrs: {
      "closeFromProp": _vm.propToCloseDropdown
    }
  }, [_c('ul', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [(!_vm.lesson.away) ? _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setActiveSplitLesson(_vm.lesson)
      }
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['split_lesson']) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.setActiveEditTimes(_vm.lesson)
      }
    }
  }, [_c('span', {
    staticClass: "icon-clock"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['edit_times']) + "\n            ")]), _vm._v(" "), _c('li', {
    staticClass: "d-item-warning",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onDeletedLesson(_vm.lesson)
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.substitution.delete_lesson')) + "\n            ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('setTheOutOfSchoolLesson', _vm.lesson)
      }
    }
  }, [_c('span', {
    staticClass: "icon-home2 icon-home2-away"
  }), _vm._v("\n              " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n            ")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('setIsCancelLesson', _vm.lesson)
      }
    }
  }, [_c('span', {
    staticClass: "icon-notification22"
  }), _vm._v("\n              " + _vm._s(!_vm.isCanceled ? _vm.i18n[_vm.locale].cancel_event : _vm.i18n[_vm.locale].uncancel_event) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-show-event__header__do-warning__container"
  }, [(_vm.isCanceled) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning do-warning--canceled"
  }, [_c('span', {
    staticClass: "icon-notification22"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale].canceled) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.isAway) ? _c('div', {
    staticClass: "d-show-event__header__do-warning do-warning"
  }, [_c('span', {
    staticClass: "icon-home2 icon-home2-away",
    staticStyle: {
      "margin-right": "2px"
    }
  }), _vm._v("\n            " + _vm._s(_vm.i18n[_vm.locale].out_of_school) + "\n          ")]) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sub-popover__container"
  }, [(_vm.lesson.event_type !== 'absence') ? [_c('ul', {
    staticClass: "sub-popover__content__body"
  }, [_c('li', [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler.choose_sub')) + "\n            ")]), _vm._v(" "), _c('dSelectSub', {
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "addClass": ['small-font'],
      "user": _vm.user,
      "eventId": _vm.lesson.id,
      "startTime": _vm.lesson.start,
      "endTime": _vm.lesson.end,
      "subs": _vm.substitutesOnLesson,
      "othersOnLesson": _vm.othersOnLesson
    },
    on: {
      "addedSubFromTeachers": function($event) {
        _vm.propStatus = 1
      },
      "add": _vm.addSubstitute,
      "remove": _vm.removeSubstitute
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler_popover.substitute_for')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), (_vm.othersOnLesson.length > 0) ? _c('li', [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-users"
  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.substitution.other_users')) + "\n            ")]), _vm._v(" "), _c('div', [_vm._l((_vm.othersOnLesson), function(other, idx) {
    return (idx < _vm.showAllOnLesson) ? _c('span', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          zIndex: 123123123123,
          onShow: function () { return other.v_isUserAbsentFromLesson.length > 0; }
        }),
        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => other.v_isUserAbsentFromLesson.length > 0\n                }"
      }],
      key: other.id,
      class: {
        'user--is-absent': other.v_isUserAbsentFromLesson.length > 0
      },
      attrs: {
        "content": other.v_isUserAbsentFromLesson
      }
    }, [_vm._v(" " + _vm._s(other.name)), (idx < _vm.othersOnLesson.length - 1) ? _c('span', [_vm._v(",")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllOnLesson < _vm.othersOnLesson.length),
      expression: "showAllOnLesson < othersOnLesson.length"
    }],
    staticClass: "text-blue pointer",
    on: {
      "click": function($event) {
        _vm.showAllOnLesson = _vm.othersOnLesson.length
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.substitution.see_all')) + "\n              ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAllOnLesson > 3),
      expression: "showAllOnLesson > 3"
    }],
    staticClass: "text-blue pointer",
    on: {
      "click": function($event) {
        _vm.showAllOnLesson = 3
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('vue2.substitution.see_less')))])], 2)]) : _vm._e(), _vm._v(" "), _c('LessonOverlapInKlass', {
    attrs: {
      "lesson": _vm.lesson
    }
  }), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle"
  }), _vm._v("\n              " + _vm._s(_vm.$t('vue2.sub_scheduler.status')) + "\n            ")]), _vm._v(" "), _c('lessonsSubstitutionStatus', {
    attrs: {
      "dropdown-placement": "bottom-start",
      "user": _vm.user,
      "statusProp": _vm.propStatus,
      "lesson": _vm.lesson,
      "othersOnLesson": _vm.othersOnLesson,
      "userCalendarId": _vm.user.user_calendar_id,
      "isSubStatusPendingActive": _vm.isSubStatusPendingActive
    }
  })], 1), _vm._v(" "), _c('li', [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v("\n              " + _vm._s(_vm.i18n[this.locale]['edit_teachers']) + "\n            ")]), _vm._v(" "), (!_vm.isEditTeacher) ? _c('div', {
    staticClass: "icon__bg-circle",
    on: {
      "click": function($event) {
        _vm.isEditTeacher = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-wrench"
  })]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInLeft"
    }
  }, [(_vm.isEditTeacher) ? _c('div', [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isUpdatingSubstitutes),
      expression: "isUpdatingSubstitutes"
    }],
    staticStyle: {
      "margin": "2rem auto"
    },
    attrs: {
      "bgColor": "#fff",
      "isExtraSmall": true
    }
  }), _vm._v(" "), _c('DSelectCalendars', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isUpdatingSubstitutes),
      expression: "!isUpdatingSubstitutes"
    }],
    attrs: {
      "itemType": "user",
      "isDeleteAllAnOption": false,
      "showTags": true,
      "event": _vm.lesson,
      "eventId": _vm.lesson.id,
      "preSelectedItems": _vm.usersOnLesson,
      "itemsThatCantBeDeleted": _vm.userCalIdsSubstituted,
      "itemsUnselectable": [],
      "showCreateButton": false,
      "isLoadingProp": _vm.isUpdatingTeachers
    },
    on: {
      "update": function($event) {
        return _vm.setUsers($event)
      }
    }
  })], 1) : _vm._e()])], 1)], 1)] : [_c('div', {
    staticClass: "pad-10",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('AbsenceReason', {
    attrs: {
      "user_calendar_id": _vm.user.user_calendar_id,
      "reason": _vm.lesson,
      "internalNote": _vm.lesson.teacher_notes
    },
    on: {
      "showLog": function($event) {
        return _vm.showLog(_vm.lesson)
      },
      "close": _vm.emitClose
    }
  })], 1)], _vm._v(" "), _c('div', {
    staticClass: "sub-popover__content__note"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_c('span', {
    staticClass: "icon-pencil"
  }), _vm._v(" "), (_vm.lesson.event_type === 'absence') ? [_vm._v(_vm._s(_vm.$t('vue2.substitution.absence_notes')))] : [_vm._v(_vm._s(_vm.$t('vue2.substitution.substitute_notes')))]], 2), _vm._v(" "), _c('weip', {
    attrs: {
      "noteType": "teacher_notes",
      "textInput": _vm.lesson.teacher_notes,
      "lesson": _vm.lesson
    },
    on: {
      "close": _vm.updateTeacherNote
    }
  })], 1)], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d159440!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/Scheduler/SchedulerItemPopover.vue
// module id = 1833
// module chunks = 1